import { useState, FC, Fragment, memo } from 'react'

import { MathVaultLink } from '~/types/math-vault'

import MenuItem from './components//MenuItem'
import SubMenu from './components/SubMenu'

interface VerticalMenuProps {
  items: MathVaultLink[]
  title: string
}

const VerticalMenuComponent: FC<VerticalMenuProps> = ({ items, title }) => {
  const [selected, setSelected] = useState('')

  function selectMenu(path: string) {
    if (selected === path) {
      setSelected(selected.slice(0, selected.lastIndexOf('/')))
    } else {
      setSelected(path)
    }
  }

  return (
    <div
      className={
        'p-6 md:p-4 m-4 lg:m-6 block ' + 'flex flex-col justify-start align-center ' + 'rounded bg-white shadow-large '
      }
    >
      <h1 className="my-4 text-purple font-semibold text-h3 text-left">{title}</h1>
      {items?.map((item) => {
        const path = item.path?.src ?? item.path
        const isSelected = selected.indexOf(path) === 0
        const itemHeight = isSelected ? 'max-h-fit-content xl:max-h-encyclopedia' : 'max-h-0'

        return (
          <Fragment key={item.key}>
            <MenuItem isLink={false} item={item} level={1} selected={selected} selectMenu={selectMenu} />
            <div
              className={`flex flex-col ml-20 overflow-hidden ${itemHeight} transition-all duration-500 ease-in-out`}
            >
              {item.children?.map((subItem) => (
                <SubMenu item={subItem} key={subItem.key} level={2} selected={selected} selectMenu={selectMenu} />
              ))}
            </div>
          </Fragment>
        )
      })}
    </div>
  )
}

export default memo(VerticalMenuComponent)
